import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { WhatsAppButton } from "./WhatsApp";

export const Header = ({ c }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const profile = c?.profile || {};
  const settings = c?.settings || {};
  const links = [
    { id: "home", label: settings.home_nav_label || "Home" },
    ...(c?.sections || []).filter((s) => s.visible !== false).map((s) => ({ id: s.id, label: s.nav_label || s.title })),
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 bg-white/95 backdrop-blur-md transition-shadow duration-300 ${scrolled ? "shadow-[0_6px_24px_-12px_rgba(30,58,138,0.25)]" : "border-b border-sky-100/60"}`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 xl:px-16">
        <a href="#home" className="flex shrink-0 items-center gap-3" data-testid="header-logo">
          {profile.logo && <img src={imgUrl(profile.logo)} alt={profile.clinic_name} className="h-11 w-11 rounded-full object-contain" />}
          <span className="font-display whitespace-nowrap text-lg font-semibold text-blue-900 sm:text-xl">{profile.clinic_name}</span>
        </a>
        <nav className="hidden items-center gap-4 xl:flex">
          {links.map((l) => (
            <a key={l.id} href={`#${l.id}`} data-testid={`nav-${l.id}`} className="whitespace-nowrap text-[15px] text-slate-700 transition-colors hover:text-pink-600">
              {l.label}
            </a>
          ))}
          <WhatsAppButton wa={c?.whatsapp} text={settings.header_button_text || "Book Appointment"} testId="header-whatsapp-btn" className="ml-1 whitespace-nowrap !px-6 !py-3" />
        </nav>
        <button className="rounded-xl p-2 text-blue-900 xl:hidden" onClick={() => setOpen((o) => !o)} data-testid="mobile-menu-btn" aria-label="Menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav className="border-t border-sky-100 bg-white px-4 pb-5 pt-2 xl:hidden" data-testid="mobile-menu">
          {links.map((l) => (
            <a key={l.id} href={`#${l.id}`} onClick={() => setOpen(false)} className="block rounded-xl px-3 py-3 text-base font-medium text-slate-700 hover:bg-sky-50">
              {l.label}
            </a>
          ))}
          <WhatsAppButton wa={c?.whatsapp} text={settings.header_button_text || "Book Appointment"} testId="mobile-menu-whatsapp-btn" className="mt-3 w-full" />
        </nav>
      )}
    </header>
  );
};
